<template>
<div>
 
<table class="table table-sm table-striped table-hover">
    <thead class="detail_">
    <tr :style="{backgroundColor : 'blue',color: 'white' ,fontSize:  '15px',fontWeight:'bold' }" >
        <th v-for="(col,index) in cols" :key="index">
            {{col}}
        </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, index) in rows" :key="index">
    <td v-for="(col,index) in cols" :key="index">
        {{item[col]}}
    </td>
    </tr>
    </tbody>
</table>
<a @click="$emit('close')" style="color:navy" class="mt-1 float-right">  <i class="fas fa-window-close ml-2" aria-hidden="true"></i></a>


</div> 
</template>

<script>

import api from '@/api'

export default {
   
   props: ['orderId','productId'],

   components: {
  
   
  },
  data () {
    return { 
        
        cols  : [],
        rows  : [],
        color : ['#006600','#990000','#660099'],     
        
       
    }
  },
  computed: 
  {   
    
  },
  created()
  {
      this.getData()
  },      
  mounted()
  {},
  methods: 
  {
      async getData()
      {
        
        this.cols = []
        this.rows = []
            
        var sp = {'sp' : 'spOrderProductDetail'}
      
        var data  = {
        'orderId'  : this.orderId,
        'productId': this.productId}
        var json  = Object.assign(data, sp)
        var arr = []


        await api.post(json).then(res => {
          if(res.status==200)
            {
                arr = res.data.recordsets[0]
                        
                this.cols.push('color')
                this.cols.push('total')
   
                var cols = arr[0]['sizes'].split('|')

                cols.forEach(item=>{
                  this.cols.push(item)
                })

                this.rows = arr
                this.$emit('finish')     

            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });



     


      }
  }
  
}
</script>

<style scoped>
.detail {
    background    : yellow;
    font-family   : 'Roboto Condensed';
    font-size     : 20px;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
</style>